export type Range = Record<'from' | 'to', string>;

export default function getMonthRange(
  month = new Date().getMonth(),
  year = new Date().getFullYear(),
) {
  const lastDate = new Date(year, month + 1, 0).getDate();

  month += 1;

  if (month < 10) {
    month = `0${month}`;
  }

  return {
    from: `${year}-${month}-01 00:00:00`,
    to: `${year}-${month}-${lastDate} 23:59:59`,
  };
}
